import api from '@pray/shared/utils/api';

import type { ProviderSeedlistResponse } from './types';

const PROVIDER_SEEDLIST_URL = '/web/studio/admin/seed-emails/provider/seedlist';

/**
 * The difference between Pray's Inbox Monster seeds and the vendor's current seed list.
 *
 * The server computes it. The prototype compared the two lists in the browser, which meant loading
 * every seed before the dialog could say anything, and it could only ever compare the page it had.
 *
 * The route is rate limited to 6 a minute because every call reaches Inbox Monster.
 */
export async function getProviderSeedlist() {
  const res = await api.executeGetRequest<{ data: ProviderSeedlistResponse }>(PROVIDER_SEEDLIST_URL);
  return res.data.data;
}
